"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingBalanceInfo = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const roundMoney_1 = require("../../../../utils/roundMoney");
const _1 = require(".");
const AccountingBalanceInfo = (props) => {
    const { balance, changeAmount, hidden, } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { className: `${_1.className}__numbers` },
        react_1.default.createElement("div", { className: `${_1.className}__balance` },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Accounting/BalanceLog/Info:Balance', defaultMessage: 'Balance:' }),
            ` ${(0, roundMoney_1.localizeMoney)(balance, locale, 'BalanceLogPage/account.balance')} CHF`),
        react_1.default.createElement("div", { className: `${_1.className}__change` },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Accounting/BalanceLog/Info:Change', defaultMessage: 'Change:' }),
            ` ${(0, roundMoney_1.localizeMoney)(changeAmount, locale, 'BalanceLogPage/changeAmount')} CHF`)));
};
exports.AccountingBalanceInfo = AccountingBalanceInfo;
//# sourceMappingURL=info.js.map